import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586eac28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-7 main-content sm:pr-8" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full sm:grid grid-cols-2 gap-8 mt-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-white ml-0 p-8 text-project font-bold" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Single-use plastic cutlery is no longer permitted in the EU. "),
    /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " The most effective solution is to use multiple-use biobased and/or biodegradable alternatives. "),
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-full",
      alt: "All cutlery image",
      src: "img/bioplastics/allset.png"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-white ml-0 p-8 text-project font-bold" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-project2 mb-4" }, "SOME SUGGESTIONS WHAT YOU CAN DO"),
    /*#__PURE__*/_createElementVNode("ul", { class: "pl-4" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "mb-4" }, " Opt for multiple-use cutlery whenever possible. "),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-4" }, " When purchasing multiple-use cutlery, look for sustainability indicators. "),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-4" }, " When ordering food delivery, let the restaurant know if you don't need disposable cutlery. "),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-4" }, " Properly dispose of the cutlery, ensuring it is sorted correctly as waste. "),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-4" }, " Stay informed about and support relevant sustainability initiatives. ")
    ])
  ])
], -1))
const _hoisted_7 = { class: "sm:col-span-1 h-full min-h-50vh flex flex-col items-center justify-center" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_11 = ["href", "innerHTML"]
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              class: "text-5xl font-bold text-project2",
              innerHTML: _ctx.$t(_ctx.config.title, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_4),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "mt-4 text-white font-bold",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _hoisted_6,
            _createVNode(_component_BackNextButtons, {
              "color-class": "mt-8 green-button",
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.config.bgImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "w-full aspect-square flex flex-col items-center justify-center",
                  style: _normalizeStyle(_ctx.config.bgStyles)
                }, [
                  _createElementVNode("p", {
                    class: "text-project font-bold mb-4",
                    innerHTML: _ctx.$t(_ctx.config.screenId+'.phyramid', {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_8),
                  _createElementVNode("img", {
                    src: _ctx.config.bgImage,
                    class: "w-full",
                    alt: "Logo"
                  }, null, 8, _hoisted_9)
                ], 4))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_11))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_12))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}